
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[pageLocale]/companies/[companySlug]",
      function () {
        return require("private-next-pages/[pageLocale]/companies/[companySlug]/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[pageLocale]/companies/[companySlug]"])
      });
    }
  